import ShowItemSkeleton from "@/components/skeleton/list.skeleton.vue";
import ShowContentSkeleton from '@/components/skeleton/content.skeleton.vue';
import HomeSkeleton from '@/components/skeleton/home.skeleton.vue';


/** 维护业务组件与骨架组件的关联 */
const skeletonMap = {
  showItem: { ...ShowItemSkeleton, name: 'showItem' },
  showContent: { ...ShowContentSkeleton, name: 'showContent' },
  home: { ...HomeSkeleton, name: 'home' }
};

export const getSkeleton = (name: keyof typeof skeletonMap) => {
  const keys = Object.keys(skeletonMap);
  if (keys.includes(name)) {
    return skeletonMap[name];
  }
  return null;
};
